/* import __COLOCATED_TEMPLATE__ from './content-source-status.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import { ContentSourceStatusType } from './content';

interface Signature {
  Args: {
    status: ContentSourceStatusType | undefined;
    isEligibleForAgent?: boolean;
    isEligibleForCopilot?: boolean;
  };
}

export default class ContentSourceStatus extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare appService: any;

  get usage() {
    // TODO: remove this once we have the real data
    return {
      agent: 109,
      all: 123,
      copilot: 123,
    };
  }

  get text() {
    if (!this.args.status) {
      return;
    }

    return (
      {
        enabled: this.intl.t('fin-ai-agent.knowledge.content-sources.status.enabled'),
        not_enabled: this.intl.t('fin-ai-agent.knowledge.content-sources.status.not_enabled'),
        enabled_for_agent: this.intl.t(
          'fin-ai-agent.knowledge.content-sources.status.enabled-for-agent',
        ),
        enabled_for_copilot: this.intl.t(
          'fin-ai-agent.knowledge.content-sources.status.enabled-for-copilot',
        ),
        syncing: this.intl.t('fin-ai-agent.knowledge.content-sources.status.syncing'),
        in_progress: this.intl.t('fin-ai-agent.knowledge.content-sources.status.in_progress'),
        error: this.intl.t('fin-ai-agent.knowledge.content-sources.status.error'),
      }[this.args.status] || this.intl.t('fin-ai-agent.knowledge.content-sources.status.enabled')
    );
  }

  get shouldShowTooltip() {
    return this.appService.app.canUseCopilotOnStandalone && this.isEnabled;
  }

  private get isEnabled() {
    if (!this.args.status) {
      return false;
    }

    return (
      this.args.status === ContentSourceStatusType.Enabled ||
      this.args.status === ContentSourceStatusType.EnabledForAgent ||
      this.args.status === ContentSourceStatusType.EnabledForCopilot
    );
  }

  get stampColor(): any {
    if (!this.args.status) {
      return;
    }

    return (
      {
        enabled: 'green',
        enabled_for_agent: 'green',
        enabled_for_copilot: 'green',
        syncing: 'yellow-light',
        in_progress: 'yellow-light',
        error: 'red',
        not_enabled: 'gray',
      }[this.args.status] || 'green'
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Knowledge::ContentSourceStatus': typeof ContentSourceStatus;
  }
}
